<div class="screen-fit">

    <app-title-header [title]="_title" [subtitle]="_subtitle" [subtitleColor]="'#0e0087'" class="d-xl-block d-none">
    </app-title-header>

    <app-steps-doctor class="steps-doctor" [steps]="steps" [uiStepsInput]="uiSteps" [currentStepInput]="currentStep"
        theme="exam-order">
    </app-steps-doctor>

    <div class="row mt-xl-3 mx-0 h-100">

        <!-- STEP 1 -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.searchPatient" [formGroup]="patientForm">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-user mr-2 icon-step"></i>
                        </div>
                    </div>

                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 1</div>
                        <h5 class="m-0 title-step">Selecciona el paciente</h5>
                    </div>
                </div>

                <div class="form-content px-4 py-3">
                    <h5 class="title-step" style="font-size: 18px;">Busca por RUT/DNI</h5>

                    <div class="input-group mb-4 autocomplete-container position-relative"
                        (click)="$event.stopPropagation()">
                        <input type="text" class="form-control form-control-rounded" placeholder="Busca por RUT/DNI"
                            [formControl]="searchCtrl" (focus)="showDropdown = true" (keydown.enter)="onEnterSearch()"
                            (keypress)="allowOnlyRutChars($event)" (paste)="onRutPaste($event)"
                            (input)="onRutSearchInput($event.target.value)" [ngClass]="{'is-invalid': searchRutInvalid}"
                            autocomplete="off">

                        <div class="dropdown-menu w-100 mt-1 show" *ngIf="showDropdown"
                            style="max-height: 320px; overflow:auto;">

                            <button class="dropdown-item disabled" *ngIf="loading">
                                Buscando…
                            </button>

                            <ng-container *ngIf="!loading">

                                <div class="dropdown-item disabled text-danger" *ngIf="searchRutInvalid">
                                    El RUT ingresado no es válido.
                                </div>

                                <div class="dropdown-item disabled"
                                    *ngIf="!searchRutInvalid && resultados.length === 0">
                                    Paciente no encontrado
                                </div>

                                <button type="button" class="dropdown-item font-weight-bold"
                                    *ngIf="puedeMostrarAgregarRutBuscado()" (click)="prepararNuevoUsuario()">
                                    + Agregar usuario con RUT {{ (searchCtrl.value || '') | uppercase }}
                                </button>

                                <div class="dropdown-divider"
                                    *ngIf="puedeMostrarAgregarRutBuscado() && resultados.length > 0"></div>

                                <button type="button" class="dropdown-item d-flex align-items-center"
                                    *ngFor="let p of resultados" (click)="seleccionarUsuario(p)">

                                    <i class="fi fi-rr-user mr-2"></i>

                                    <div class="d-flex flex-column text-left">
                                        <strong>{{ p.use_name }} {{ p.use_paternal_surname }}</strong>
                                        <small class="text-muted">{{ p.use_username || p.use_rut }}</small>
                                    </div>
                                </button>

                            </ng-container>
                        </div>
                    </div>

                    <h5 class="title-step" style="font-size: 18px;">Completa los datos del paciente</h5>
                    <h5 class="title-step">Datos personales</h5>

                    <div class="form-row">

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">RUT*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="RUT"
                                formControlName="use_rut" [readonly]="true" (keypress)="allowOnlyRutChars($event)">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Nombre*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Nombre"
                                formControlName="use_name" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Apellido Paterno*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Apellido Paterno"
                                formControlName="paterno" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Apellido Materno</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Apellido Materno"
                                formControlName="materno" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Fecha de nacimiento*</label>
                            <input type="date" class="form-control form-control-rounded" formControlName="nacimiento">
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <div class="form-row no-gutters">

                                <div class="col-4 col-md-4 pr-2">
                                    <label class="label-sm">Código de Área</label>

                                    <div class="custom-select-flag" (click)="onAreaCodeDropdownClick($event)"
                                        [class.open]="flagDropdownOpen" [class.disabled]="!step1Unlocked">

                                        <div class="selected d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <span class="fi mr-2" [ngClass]="selectedAreaCode?.cou_flag"
                                                    style="font-size: 10px;"></span>
                                                (+{{ selectedAreaCode?.cou_phone_code }})
                                            </div>

                                            <i class="fi fi-rr-angle-small-down"></i>
                                        </div>

                                        <div class="options" *ngIf="flagDropdownOpen">
                                            <div class="option" *ngFor="let areaCode of areaCodes"
                                                (click)="selectAreaCode(areaCode); $event.stopPropagation()">
                                                <span class="fi mr-2" [ngClass]="areaCode.cou_flag"></span>
                                                (+{{ areaCode.cou_phone_code }})
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-md-8">
                                    <label class="label-sm">Teléfono*</label>

                                    <input type="tel" class="form-control form-control-rounded" placeholder="Teléfono"
                                        formControlName="telefono" (keypress)="allowOnlyNumbers($event)"
                                        [attr.minlength]="selectedAreaCode?.cou_min_phone"
                                        [attr.maxlength]="selectedAreaCode?.cou_max_phone"
                                        maxlength="{{ selectedAreaCode?.cou_max_phone || 15 }}"
                                        [readonly]="!step1Unlocked">

                                    <small class="text-muted d-block m-0" *ngIf="selectedAreaCode">
                                        Ingrese número entre {{ selectedAreaCode?.cou_min_phone }} y
                                        {{ selectedAreaCode?.cou_max_phone }} dígitos.
                                    </small>
                                </div>

                            </div>
                        </div>

                        <div class="form-group col-12">
                            <label class="label-sm">Correo electrónico*</label>
                            <input type="email" class="form-control form-control-rounded"
                                placeholder="Correo electrónico" formControlName="email" [readonly]="!step1Unlocked">
                        </div>

                        <div class="col-12 mt-2">
                            <!-- <hr> -->
                            <h5 class="title-step">Dirección</h5>
                        </div>

                        <div class="form-group col-lg-12 col-xl-4">
                            <label class="label-sm">País*</label>
                            <select class="form-control form-control-rounded" formControlName="use_address_cou_id">
                                <option [ngValue]="null">
                                    {{ loadingPaises ? 'Cargando países...' : 'Seleccione país' }}
                                </option>

                                <option *ngFor="let pais of paises" [ngValue]="pais.cou_id">
                                    {{ pais.cou_name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-lg-12 col-xl-4">
                            <label class="label-sm">Región*</label>
                            <select class="form-control form-control-rounded" formControlName="use_address_reg_id">
                                <option [ngValue]="null">
                                    {{ loadingRegiones ? 'Cargando regiones...' : 'Seleccione región' }}
                                </option>

                                <option *ngFor="let region of regiones" [ngValue]="region.reg_id">
                                    {{ region.reg_name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-lg-12 col-xl-4">
                            <label class="label-sm">Comuna*</label>
                            <select class="form-control form-control-rounded" formControlName="use_address_com_id">
                                <option [ngValue]="null">
                                    {{ loadingComunas ? 'Cargando comunas...' : 'Seleccione comuna' }}
                                </option>

                                <option *ngFor="let comuna of comunas" [ngValue]="comuna.com_id">
                                    {{ comuna.com_name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Dirección / Calle*</label>
                            <input type="text" class="form-control form-control-rounded"
                                placeholder="Ej: Av. Providencia" formControlName="use_address_street"
                                [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-group col-lg-12 col-xl-2">
                            <label class="label-sm">Número*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Ej: 123"
                                formControlName="use_address_number" [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-group col-lg-12 col-xl-4">
                            <label class="label-sm">Depto/Oficina</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Ej: Depto 401"
                                formControlName="use_address_rest" [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-footer col-12">
                            <div class="d-flex justify-content-center">

                                <button type="button" class="btn btn-light btn-pill mr-2" (click)="volverTalonario()">
                                    Volver
                                </button>

                                <button type="button" class="btn btn-secondary btn-pill" [disabled]="!isStep1Valid()"
                                    (click)="nextFromStep1()">
                                    Siguiente
                                </button>


                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <!-- STEP 2 -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.examOrderData" [formGroup]="examOrderForm">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-document mr-2 icon-step"></i>
                        </div>
                    </div>

                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 2</div>
                        <h5 class="m-0 title-step">Escribe la orden</h5>
                    </div>
                </div>

                <div class="form-content form-content-step2 px-4 py-3">
                    <h5 class="title-step">Completa la orden de examen</h5>

                    <div class="form-row step2-form-row">
                        <div class="form-group col-12">
                            <label class="label-sm">Tipo de examen*</label>

                            <select class="form-control form-control-rounded" formControlName="id_exam">
                                <option value="" disabled>Seleccione examen</option>

                                <option *ngFor="let examen of (examenes?.examenes || [])" [value]="examen.exa_typ_id">
                                    {{ examen.exa_typ_name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group col-12">
                            <label class="label-sm">Orden de examen*</label>

                            <textarea class="form-control textarea-receta" rows="8"
                                placeholder="Ingrese orden de examen" formControlName="ordersText">
              </textarea>
                        </div>

                        <div class="form-footer col-12">
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-light btn-pill mr-2" (click)="volverStep1()">
                                    Volver
                                </button>

                                <button type="button" class="btn btn-secondary btn-pill" [disabled]="!isStep2Valid()"
                                    (click)="nextFromStep2()">
                                    Siguiente
                                </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

        <!-- STEP 3 -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.examOrderSignature" [formGroup]="examOrderForm">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-document-signed mr-2 icon-step"></i>
                        </div>
                    </div>

                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 3</div>
                        <h5 class="m-0 title-step">Genera la orden</h5>
                    </div>
                </div>

                <div class="form-content form-content-signature px-4 py-3">

                    <div class="signature-box">

                        <!-- <div class="signature-icon">
          <i class="fi fi-rr-document-signed"></i>
        </div> -->

                        <h5 class="signature-title">
                            Selecciona la firma que vas a utilizar
                        </h5>

                        <!-- <p class="signature-subtitle">
                            Selecciona el tipo de firma que deseas aplicar al documento.
                        </p> -->

                        <button type="button" class="btn signature-btn"
                            [ngClass]="{ 'active': signatureType === 'digital' }" (click)="setSignatureType('digital')">
                            Firma electrónica simple
                        </button>

                        <small class="text-danger d-block mt-3"
                            *ngIf="examOrderForm.get('signatureType')?.touched && !signatureType">
                            Debes seleccionar un tipo de firma.
                        </small>

                        <!-- <small class="text-muted d-block mt-3" *ngIf="loadingCrearOrden">
                            Generando orden de examen...
                        </small> -->

                        <small class="text-danger d-block mt-3" *ngIf="errorCrearOrden">
                            {{ errorCrearOrden }}
                        </small>

                    </div>

                    <div class="signature-footer">
                        <button type="button" class="btn btn-light btn-pill mr-2" [disabled]="loadingCrearOrden"
                            (click)="volverStep2()">
                            Volver
                        </button>

                        <button type="button" class="btn btn-secondary btn-pill"
                            [disabled]="!isStep3Valid() || loadingCrearOrden" (click)="nextFromStep3()">
                            Siguiente
                        </button>
                    </div>

                </div>

            </div>
        </div>

        <!-- STEP 4 -->
        <ng-container *ngIf="steps.examOrderSummary">

            <!-- COLUMNA IZQUIERDA: ÉXITO / DESCARGA / REENVÍO -->
            <div class="col-xl-6 col-12 p-0 pr-xl-2 left-col-fill">
                <div class="card h-100 p-0 card-left form-card step4-card">

                    <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                        <div class="step d-flex flex-column align-items-center">
                            <div class="step-icon">
                                <i class="fi fi-rr-envelope mr-2 icon-step"></i>
                            </div>
                        </div>

                        <div>
                            <div class="text-uppercase text-muted small mb-1">Paso 4</div>
                            <h5 class="m-0 title-step">Envía la orden</h5>
                        </div>
                    </div>

                    <div class="form-content step4-content px-4 py-3">

                        <div class="step4-success-box">
                            <div class="step4-success-icon">
                                <i class="fi fi-rr-check"></i>
                            </div>

                            <h4 class="step4-success-title">
                                Tu orden de examen ha sido generada con éxito
                            </h4>

                            <!-- <p class="step4-success-subtitle" *ngIf="respuestaCrearOrden?.id_medical_order">
                                ID orden: {{ respuestaCrearOrden?.id_medical_order }}
                            </p> -->
                        </div>

                        <div class="step4-section">
                            <p class="step4-section-title">
                                Puedes descargar la orden aquí
                            </p>

                            <button type="button" class="btn btn-secondary btn-pill" [disabled]="!documentoGeneradoUrl"
                                (click)="descargarOrdenGenerada()">
                                Descargar orden
                            </button>
                        </div>

                        <div class="step4-section resend-section">
                            <p class="step4-section-title">
                                Enviar la orden a tu paciente con otro correo
                            </p>

                            <div class="resend-form">
                                <div class="resend-input-wrapper">
                                    <label class="label-sm">Correo electrónico</label>

                                    <input type="email" class="form-control form-control-rounded"
                                        placeholder="correopaciente@ejemplo.com" [formControl]="resendEmailCtrl"
                                        [ngClass]="{ 'is-invalid': resendEmailCtrl.invalid && resendEmailCtrl.touched }">
                                </div>

                                <button type="button" class="btn btn-secondary resend-btn" [disabled]="loadingReenvio"
                                    (click)="reenviarOrdenPorCorreo()">
                                    Enviar
                                </button>
                            </div>

                            <small class="text-danger d-block mt-2" *ngIf="errorReenvio">
                                {{ errorReenvio }}
                            </small>

                            <small class="text-success d-block mt-2" *ngIf="mensajeReenvio">
                                {{ mensajeReenvio }}
                            </small>

                            <small class="step4-help-text d-block mt-2">
                                La orden será enviada al correo indicado y quedará disponible en el perfil del paciente
                                dentro de la plataforma AlmaMedis, en la sección “Mis documentos”.
                            </small>
                        </div>

                        <div class="step4-footer-actions">

                            <button type="button" class="btn btn-light btn-pill mr-2" (click)="generarNuevaOrden()">
                                Generar nueva orden
                            </button>

                            <button type="button" class="btn btn-secondary btn-pill" (click)="volverTalonario()">
                                Volver a talonario
                            </button>

                        </div>

                    </div>

                </div>
            </div>

            <!-- COLUMNA DERECHA: PREVISUALIZACIÓN PDF -->
            <div class="col-xl-6 col-12 p-0 pl-xl-2 left-col-fill">
                <div class="card h-100 p-0 document-preview-card">

                    <div class="document-preview-header">
                        <h5 class="m-0">
                            <i class="fi fi-rr-document"></i>
                            Resumen de orden generada
                        </h5>

                        <p class="m-0 text-muted">
                            Previsualización del documento generado.
                        </p>
                    </div>

                    <div class="document-preview-body" *ngIf="safeDocumentoGeneradoUrl; else noPreview">
                        <iframe class="document-preview-frame" [src]="safeDocumentoGeneradoUrl"
                            title="Previsualización orden de examen">
                        </iframe>
                    </div>

                    <ng-template #noPreview>
                        <div class="document-preview-empty">
                            <i class="fi fi-rr-document"></i>

                            <p>No fue posible cargar la previsualización del documento.</p>

                            <button type="button" class="btn generated-outline-btn" *ngIf="documentoGeneradoUrl"
                                (click)="descargarOrdenGenerada()">
                                Abrir documento
                            </button>
                        </div>
                    </ng-template>

                    <!-- <div class="document-preview-actions" *ngIf="documentoGeneradoUrl">
            <button
              type="button"
              class="btn generated-outline-btn"
              (click)="descargarOrdenGenerada()">
              Abrir documento
            </button>
          </div> -->

                </div>
            </div>

        </ng-container>

        <!-- RESUMEN LATERAL NORMAL: SOLO PASOS 1, 2 Y 3 -->
        <div class="col-xl-4 d-none d-xl-block pl-xl-2 pr-0" *ngIf="!steps.examOrderSummary">

            <div class="card h-100 exam-summary-card">

                <div class="summary-main-header">
                    <div class="summary-main-icon">
                        <i class="fi fi-rr-document" style="display: flex;
    justify-content: center;"></i>
                    </div>

                    <div>
                        <h6 class="summary-main-title">
                            Resumen de orden
                        </h6>

                        <p class="summary-main-subtitle">
                            Los datos se actualizarán automáticamente.
                        </p>
                    </div>
                </div>

                <div class="summary-section">

                    <div class="summary-section-header">
                        <span class="summary-section-icon">
                            <i class="fi fi-rr-user"></i>
                        </span>

                        <span class="summary-section-title">
                            Datos del paciente
                        </span>
                    </div>

                    <div class="summary-row">
                        <div class="summary-label">
                            <i class="fi fi-rr-user"></i>
                            <span>Nombre</span>
                        </div>

                        <div class="summary-value">
                            {{ patientData.use_name || '—' }}
                            {{ patientData.paterno || '' }}
                            {{ patientData.materno || '' }}
                        </div>
                    </div>

                    <div class="summary-row">
                        <div class="summary-label">
                            <i class="fi fi-rr-credit-card-buyer"></i>
                            <span>RUT/DNI</span>
                        </div>

                        <div class="summary-value">
                            {{ patientData.use_rut || '—' }}
                        </div>
                    </div>

                    <div class="summary-row">
                        <div class="summary-label">
                            <i class="fi fi-rr-calendar"></i>
                            <span>Nacimiento</span>
                        </div>

                        <div class="summary-value">
                            {{ patientData.nacimiento ? (patientData.nacimiento | date:'dd-MM-yyyy') : '—' }}
                        </div>
                    </div>

                    <div class="summary-row">
                        <div class="summary-label">
                            <i class="fi fi-rr-envelope"></i>
                            <span>Email</span>
                        </div>

                        <div class="summary-value">
                            {{ patientData.email || '—' }}
                        </div>
                    </div>

                    <div class="summary-row">
                        <div class="summary-label">
                            <i class="fi fi-rr-phone-call"></i>
                            <span>Teléfono</span>
                        </div>

                        <div class="summary-value">
                            (+{{ patientData.telefonoCodigo || '—' }}) {{ patientData.telefono || '—' }}
                        </div>
                    </div>

                </div>

                <div class="summary-section">

                    <div class="summary-section-header">
                        <span class="summary-section-icon">
                            <i class="fi fi-rr-marker"></i>
                        </span>

                        <span class="summary-section-title">
                            Dirección
                        </span>
                    </div>

                    <div class="summary-row summary-row-simple">
                        <div class="summary-label-simple">País</div>

                        <div class="summary-value">
                            {{ getPaisNombre(patientData.use_address_cou_id) || '—' }}
                        </div>
                    </div>

                    <div class="summary-row summary-row-simple">
                        <div class="summary-label-simple">Región</div>

                        <div class="summary-value">
                            {{ getRegionNombre(patientData.use_address_reg_id) || '—' }}
                        </div>
                    </div>

                    <div class="summary-row summary-row-simple">
                        <div class="summary-label-simple">Comuna</div>

                        <div class="summary-value">
                            {{ getComunaNombre(patientData.use_address_com_id) || '—' }}
                        </div>
                    </div>

                    <div class="summary-row summary-row-simple">
                        <div class="summary-label-simple">Dirección</div>

                        <div class="summary-value">
                            {{ patientData.use_address_street || '—' }}
                            {{ patientData.use_address_number || '' }}
                        </div>
                    </div>

                    <div class="summary-row summary-row-simple">
                        <div class="summary-label-simple">Depto/Oficina</div>

                        <div class="summary-value">
                            {{ patientData.use_address_rest || '—' }}
                        </div>
                    </div>

                </div>

                <div class="summary-section" *ngIf="steps.examOrderData || steps.examOrderSignature">

                    <div class="summary-section-header">
                        <span class="summary-section-icon">
                            <i class="fi fi-rr-document-signed"></i>
                        </span>

                        <span class="summary-section-title">
                            Orden de examen
                        </span>
                    </div>

                    <div class="summary-order-meta">

                        <div class="summary-meta-card">
                            <div class="summary-meta-icon">
                                <i class="fi fi-rr-document"></i>
                            </div>

                            <div>
                                <span class="summary-meta-label">Tipo</span>

                                <strong>
                                    {{ getTipoExamenNombre(examOrderData.id_exam) || '—' }}
                                </strong>
                            </div>
                        </div>

                        <div class="summary-meta-card">
                            <div class="summary-meta-icon">
                                <i class="fi fi-rr-pen-clip"></i>
                            </div>

                            <div>
                                <span class="summary-meta-label">Firma</span>

                                <strong>
                                    {{ getSignatureName() || '—' }}
                                </strong>
                            </div>
                        </div>

                    </div>

                    <div class="summary-subsection-title">
                        <i class="fi fi-rr-calendar-lines-pen"></i>
                        <span>Indicación</span>
                    </div>

                    <div class="summary-indications-box">
                        {{ examOrderData.ordersText || '—' }}
                    </div>

                </div>

                <div class="summary-alert" *ngIf="!isStep1Valid()">
                    <i class="fi fi-rr-info"></i>

                    <span>
                        Asegúrate que los datos del paciente estén completos.
                    </span>
                </div>

            </div>
        </div>

    </div>
</div>